module.exports = __webpack_public_path__ + "img/end-of-month-right.beb975ed.svg";